module.exports = __webpack_public_path__ + "static/media/jerikan-transparent.8450eeb9.png";